export enum Glove {
  None,
  Power,
  Titan
}
